import React from 'react';
import EditableBranchTemplate from '../components/EditableBranchTemplate';
import { developmentData } from '../data/developmentData';

const Development = () => {
  const handleSave = (updatedContent) => {
    console.log('Saving updated content:', updatedContent);
    alert('Content saved successfully! (Check console for details)');
  };

  return (
    <EditableBranchTemplate
      title="Web3 Development"
      sections={developmentData}
      onSave={handleSave}
    />
  );
};

export default Development;
